<template>
  <v-app>
    <div class="main-logo d-flex justify-space-between">
      <img src="/logo.png">
      <span class="d-flex align-center">Личный кабинет</span>
    </div>
    <v-row class="main-loyalty">
      <router-view />
    </v-row>
  </v-app>
</template>

<script>
  export default {
    name: 'MainLoyalty',

    components: {
    },

    data: () => ({
      expandOnHover: false,
      companyName: null
      // snackbar: {
      //   text: '',
      //   show: false,
      // },
    }),
    // watch: {
    //   '$store.state.snackbar.show': function () {
    //     this.snackbar = this.$store.state.snackbar
    //   },
    // },
    // created () {
    //   this.$watch(
    //       () => this.$route.params,
    //       () => this.fetchCustomerName()
    //   )
    // },
    mounted () {
      console.log('MainLoyalty is mounted')
      this.fetchCustomerData()
    },
    methods: {
      fetchCustomerData () {
        // console.log('fetchCustomerName:', this.$route.query.name)
          if (this.$route.query.id) {
              localStorage.setItem('customer', this.$route.query.id)
          }

          if (this.$route.query.number) {
            localStorage.setItem('customerNumber', this.$route.query.number)
        }
      },
      onChangeCompanyName (customerShortName) {
        this.companyName = customerShortName
      },
    }
  }
</script>
<style scoped>
.main-loyalty {
    background-image: url("/black-friday-gift.png");
    background-size: cover;
}
.main-logo {
    padding: 5px;
    height: 50px;
}
.main-logo img {
    height: 40px;
}
.main-logo span {
    font-size: 1.5rem;
    color: blue;
}
</style>
